import React, { Component } from "react";
import { Link, Switch, Route, BrowserRouter as Router } from "react-router-dom";
import app from "../base";
import ShowRentals from "../components/ShowRentals";
import AddRental from "../components/AddRentals";
import EditRental from "../components/EditDeleteRentals";
import DetailRental from "../components/DetailRental";

class AdminPage extends Component {
  constructor(props) {
    super(props);
    this.ref = app.firestore().collection("rentals");
    this.unsubscribe = null;
    this.state = {
      rentals: [],
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const rentals = [];
    querySnapshot.forEach((doc) => {
      const {
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      } = doc.data();
      rentals.push({
        key: doc.id,
        doc, // DocumentSnapshot
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      });
    });
    this.setState({
      rentals,
    });
  };

  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }

  render() {
    return (
      <div class="container">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title" style={{ marginTop: 50 }}>
              RENTAL LIST
            </h3>
          </div>
          <div class="panel-body">
            <h4>
              <Link to="/admin/create">Add Rental</Link>
            </h4>
            <Switch>
              <Route exact path="/admin">
                <ShowRentals />
              </Route>
              <Route path="/admin/create">
                <AddRental />
              </Route>
              <Route
                path="/admin/show/:id"
                render={(props) => <DetailRental {...props} />}
              />
              <Route
                path="/admin/edit/:id"
                render={(props) => <EditRental {...props} />}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminPage;
